import { ThemeOptions } from '@mui/material';

export const themeAutocomplete: ThemeOptions['components'] = {
  MuiAutocomplete: {
    styleOverrides: {
      groupLabel: {
        lineHeight: 2,
      },
      inputRoot: {
        '&.MuiInputBase-root.MuiOutlinedInput-root': {
          height: 'auto',
        },
      },
    },
  },
};
